
export interface ProductPrice {
  id: number;
  productId: number;
  productCode: string;
  productType: string;
  productDescription: string;
  cost: number;
  percentage: number;
}

export interface SubscriptionPlan {
  id: number;
  name: string;
  description: string;
  price: number;
  billingInterval: 'MONTHLY' | 'YEARLY' | string;
  sortOrder: number;
  active: boolean;
  trialDays: number;
  trialEligible: boolean;
  marketId?: number;
  targetCountryId?: number | null;
  productPrices: ProductPrice[];
  isDefault: boolean;
}

export enum SubscriptionStatus {
  TRIAL = 'TRIAL',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  SUSPENDED = 'SUSPENDED',
  PENDING_CANCELLATION = 'PENDING_CANCELLATION',
}

export interface AccountSubscription {
  id: number;
  accountId: number;
  plan: SubscriptionPlan;
  status: SubscriptionStatus;
  autoRenewal: boolean;
  active: boolean;
  inTrial: boolean;
  startedAt?: string;
  expiresAt?: string;
  cancelledAt?: string;
  trialEndsAt?: string;
  lastBilledAt?: string;
}

export interface SubscriptionFilters {
  accountId?: number;
  planId?: number;
  status?: SubscriptionStatus;
}
